import {IJobDefinitionStep} from "./JobDefinitionStep";
import {ITag} from "./Tag";

export interface IJobDefinition {
	id: number;
	name: string;
	description: string;
	inputType: InputType;
	jobSteps: IJobDefinitionStep[];
	tags?: ITag[];
}

export enum InputType {
	Anva = "ANVA",
	Csv = "CSV",
	None = "NONE"
}
